// src/components/img/GalerySectionVessels/VesselgslVioletta.tsx
import React from 'react';
import vesselImage from './gslVioletta.jpeg';

const VesselgslVioletta: React.FC = () => (
  <img src={vesselImage} alt="Vessel gslVioletta" />
);

export default VesselgslVioletta;